window.$mm_measures_webgisId = "";
window.$mm_measures_selectedRow = "";
window.$mm_measures_content = [];
window.$mm_measures_result = [];
window.$mm_measures_lastUsedTableFilter = [];
window.$mm_measures_columnList = [];
window.$mm_measures_algemeenGisratioid = [];
window.$mm_measures_maatregelNaam = [];
window.$mm_measures_planningspatroonNaam = [];
window.$mm_measures_planningsperiodeNaam = [];
window.$mm_measures_scroll_change = false;
window.$mm_measures_gvv = 1;
window.$mm_measures_filterMaatregelenIsActive = [];
window.$mm_measures_filterPlannigIsActive = [];
window.$mm_measures_filterContent = [];
window.$mm_measures_filterClickStatus = false;
window.$mm_measures_filterClickStatusPlannig = false;
window.$mm_measures_filterCheckControlMaat = [false, false];
window.$mm_measures_filterCheckControlPlann = [false, false];
window.$mm_measures_page_number = 1;
window.$mm_management_planningspatroonPageNUmber = 1;
window.$mm_management_planningsperiodePageNUmber = 1;
window.$mm_measures_Glist = [];
window.$mm_measures_model_context = [];
window.$mm_measures_selectedIds = [];
window.$mm_measures_table_total_row_count = 0;
window.$mm_measures_columnListPure = null;
window.$mm_measures_refreshFunction = function (){};

window.$mm_measures_actions = [
  {
    id: "94ea165f-4df5-4fad-8566-41b42eb8d493",
    text: "Plaats in gebied",
    class: "locate",
    modal: "gebied_plaatsen",
  },
  {
    id: "e7bc8b48-5f58-4177-9fae-a0fe5a1e81a0",
    text: "Update prestatieveld*",
    class: "locate",
    modal: "prestatieveld.update",
  },
  {
    id: "3dcddc6d-77da-4b4b-8f48-534241a3804e",
    text: "Wijzigen discipline",
    class: "locate",
    modal: "discipline.wijzigen",
  },
  {
    id: "dd3088ff-9042-4643-a22d-dd24e0781cdf",
    text: "Toevoegen beheeractiviteit",
    class: "locate",
    modal: "beheeractiviteit.toevoegen",
  },
  {
    id: "08dd5290-f3bb-44f8-8331-6501d0ed6f2a",
    text: "Aanmaken correctief onderhoud",
    class: "locate",
    modal: "correctief.onderhoud",
  },
  {
    id: "8b7e4342-6135-4670-b30a-a084f4d5c9d8",
    text: "Update locatie",
    class: "locate",
    modal: "locatie.update",
  },
  {
    id: "16514ed7-9d02-47ec-bc93-6cf6b15225b4",
    text: "Koppelen werkbron",
    class: "locate",
    modal: "koppelen_werkbron",
  },
  {
    id: "PLAATS_IN_GLOBALE_PLANNING",
    text: "Plaats in Globale planning",
    class: "locate",
    modal: "plaats_in_globale_planning",
  },
  {
    id: "measures_toon_dossiers_op_kaart",
    text: "measures_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
];

/* window.$mm_measures_actions = [
  {
    id: "94ea165f-4df5-4fad-8566-41b42eb8d493",
    text: "Plaats in gebied",
    class: "locate",
    modal: "gebied_plaatsen",
  },
  {
    id: "e7bc8b48-5f58-4177-9fae-a0fe5a1e81a0",
    text: "Update prestatieveld*",
    class: "locate",
    modal: "prestatieveld.update",
  },
  {
    id: "3dcddc6d-77da-4b4b-8f48-534241a3804e",
    text: "Wijzigen discipline",
    class: "locate",
    modal: "discipline.wijzigen",
  },
  {
    id: "dd3088ff-9042-4643-a22d-dd24e0781cdf",
    text: "Toevoegen beheeractiviteit",
    class: "locate",
    modal: "beheeractiviteit.toevoegen",
  },
  {
    id: "08dd5290-f3bb-44f8-8331-6501d0ed6f2a",
    text: "Aanmaken correctief onderhoud",
    class: "locate",
    modal: "correctief.onderhoud",
  },
  {
    id: "8b7e4342-6135-4670-b30a-a084f4d5c9d8",
    text: "Update locatie",
    class: "locate",
    modal: "locatie.update",
  },
  {
    id: "16514ed7-9d02-47ec-bc93-6cf6b15225b4",
    text: "Koppelen werkbron",
    class: "locate",
    modal: "koppelen_werkbron",
  },
  {
    id: "ec5d1e75-6160-4f16-9c1c-fcaf6d271512",
    text: "Plaats in Globale planning",
    class: "locate",
    modal: "plaats_in_globale_planning",
  },
  {
    id: "measures_toon_dossiers_op_kaart",
    text: "measures_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
]; */

window.$mm_measures_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>measures",
        column_list: [
          "checkbox",
          "measures",
          "measures_plannig",
          "Gisratio ID",
          "Maatregel",
          "Discipline",
          "Planningspatroon",
          "Planningsperiode",
        ],
      },
    ],
  },
};
